import React from "react";
import { Route } from "react-router";
import { Navigate } from "react-router-dom";
import { AuthorizedRoute } from "../../shared/components/Routers";
import { Roles } from "../../account/models/AccountModels";
import Users from "../components/users/Users";
import Customers from "../components/customers/Customers";
import Machines from "../components/machines/Machines";
import Leads from "../components/leads/Leads";
import Products from "../components/catalog/Products";
import Inventory from "../components/inventory/Inventory";
import EditInventory from "../components/inventory/EditInventory";
import UploadProductsFile from "../components/catalog/UploadProductsFile";
import Rfqs from "../components/rfqs/Rfqs";
import Offers from "../components/offers/Offers";

const useAdminRoutes = () => {
  return (
    <Route path="" element={<AuthorizedRoute role={Roles.SYSTEM_ADMINISTRATOR} />}>
      <Route path="offers" element={<Offers />}></Route>
      <Route path="rfqs" element={<Rfqs />}></Route>
      <Route path="users" element={<Users />}></Route>
      <Route path="customers" element={<Customers />}></Route>
      <Route path="machines" element={<Machines />}></Route>
      <Route path="leads" element={<Leads />}></Route>
      <Route path="catalog" element={<Products />}></Route>
      <Route path="catalog/upload" element={<UploadProductsFile />}></Route>
      <Route path="inventory" element={<Inventory />}></Route>
      <Route path="inventory/:id" element={<EditInventory/>}></Route>
      <Route path="" element={<Navigate to="offers" />} />
      <Route path="*" element={<Navigate to="admin" />} />
    </Route>
  )
};

export default useAdminRoutes;